import { render, staticRenderFns } from "./addAndEditRegion.vue?vue&type=template&id=6c3ef12a&"
import script from "./addAndEditRegion.vue?vue&type=script&lang=js&"
export * from "./addAndEditRegion.vue?vue&type=script&lang=js&"
import style0 from "./addAndEditRegion.vue?vue&type=style&index=0&id=6c3ef12a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports